import { render } from "./personalSpeech.vue?vue&type=template&id=2cfe9056&scoped=true"
import script from "./personalSpeech.vue?vue&type=script&lang=js"
export * from "./personalSpeech.vue?vue&type=script&lang=js"

import "./personalSpeech.vue?vue&type=style&index=0&id=2cfe9056&lang=less&scoped=true"
import "./personalSpeech.vue?vue&type=style&index=1&id=2cfe9056&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfe9056"]])

export default __exports__